// extracted by mini-css-extract-plugin
export default {"secao-banner":"Banner_secao-banner__TW5gy","bolinhas-banner":"Banner_bolinhas-banner__0jqrN","moverBolinhas":"Banner_moverBolinhas__cZvKS","botao-oni":"Banner_botao-oni__K86sD"};